/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationEnrollmentGridChildren200,
  GetApiV1CourseregistrationEnrollmentGridChildren401,
  GetApiV1CourseregistrationEnrollmentGridChildren500,
  GetApiV1CourseregistrationEnrollmentGridChildrenQueryParams,
  GetApiV1CourseregistrationEnrollmentGridChildrenQueryResponse,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentGridChildren.ts";
import { courseRegistrationEnrollmentChildViewModelSchema } from "../courseRegistrationEnrollmentChildViewModelSchema.ts";
import { eCompanyFilterTypeSchema } from "../eCompanyFilterTypeSchema.ts";
import { eDocumentSelectFilterSchema } from "../eDocumentSelectFilterSchema.ts";

export const getApiV1CourseregistrationEnrollmentGridChildrenQueryParamsSchema =
  z.object({
    ClassStudentId: z.optional(z.coerce.number().int()),
    PoloId: z.optional(z.coerce.number().int()),
    Filter: z.optional(
      z
        .lazy(() => eCompanyFilterTypeSchema)
        .describe("1 = Main | 2 = Company | 3 = All | "),
    ),
    CompanyId: z.optional(z.coerce.number().int()),
    Status: z.optional(z.coerce.number().int()),
    StudentName: z.optional(z.string()),
    Email: z.optional(z.string()),
    Cpf: z.optional(z.string()),
    Documents: z.optional(
      z
        .lazy(() => eDocumentSelectFilterSchema)
        .describe("0 = All | 1 = WithDocuments | 2 = WithoutDocuments | "),
    ),
    DocumentStartDate: z.optional(z.string().datetime()),
    DocumentEndDate: z.optional(z.string().datetime()),
    pageNumber: z.coerce.number().int().default(1),
    pageSize: z.coerce.number().int().default(20),
  }) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentGridChildrenQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationEnrollmentGridChildren200Schema =
  z.array(
    z.lazy(() => courseRegistrationEnrollmentChildViewModelSchema),
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentGridChildren200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationEnrollmentGridChildren401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentGridChildren401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationEnrollmentGridChildren500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentGridChildren500>;

export const getApiV1CourseregistrationEnrollmentGridChildrenQueryResponseSchema =
  z.lazy(
    () => getApiV1CourseregistrationEnrollmentGridChildren200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentGridChildrenQueryResponse>;
